import React, { useState, useEffect } from 'react';
import moment from 'moment';

// Assets
import InsIcon from 'Assets/images/GearInsIcon.png';
import RobotIcon from 'Assets/images/GearCamIcon.png';

// Styles
import {
  Collabolators,
  CollabolatorsAvatar,
  EachCollabolatorsP,
  EachCollabolatorsP2Div,
  EachCollabolatorsP3P,
  EachCollabolatorsP5P,
  EachCollabolatorsP6P,
  GearAvatarDiv,
  GearListRow,
  GearListCell,
  GearSubscriptionStatusText,
} from '../styles';

// Config
import { deviceTypeFilterOptions, gearSubscriptionStatusFilterOptions } from 'Config/gearAssetsConstant';

// Components
import SearchFooter from './SearchFooter';

const PLACEHOLDER = '-';
const formatDate = value => (value ? moment(value).format('MMM D, YYYY') : PLACEHOLDER);

const GearsList = ({
  editGear,
  allOrgGears,
  nameFilter,
  deviceTypeFilter,
  subStatusFilter,
  indexOfLastPost,
  indexOfFirstPost,
  postsPerPage,
  setCurrentPage,
  currentPage,
  prePage,
  nextPg,
}) => {
  const [gearsList, setGearsList] = useState([]);

  useEffect(() => {
    let tempGearsList = allOrgGears
      ?.map(gear => {
        if (!gear.nickname) {
          gear['nickname'] = (gear?.nick_name || gear?.robot_org_nick_name);
        }
        return gear;
      })
      .filter(gear => {
        return gear.nickname.toLowerCase().includes(nameFilter.toLowerCase().trim());
      })
      .filter(gear => {
        if (deviceTypeFilter.value === (deviceTypeFilterOptions[0].value)) {
          return gear
        } else if (deviceTypeFilter.value === (gear?.instance_type || gear?.device_details?.device_type)) {
          return gear
        }
      })
      .filter(gear => {
        if (subStatusFilter.value === gearSubscriptionStatusFilterOptions[0].value) {
          return true;
        }
        if (subStatusFilter.value === 'NONE') {
          return !gear?.subscription;
        }
        return gear?.subscription?.status === subStatusFilter.value;
      });
    setGearsList(tempGearsList);
  }, [
    nameFilter,
    deviceTypeFilter,
    subStatusFilter,
    allOrgGears,
  ]);

  return (
    <>
      <Collabolators>
        {gearsList?.slice(indexOfFirstPost, indexOfLastPost)
          ?.map((gearData, index) => {
            const deviceType = deviceTypeFilterOptions.find(type => type.value === (gearData?.instance_type || gearData?.device_details?.device_type))?.label ?? 'Unknown';
            const nickname = gearData?.nickname;
            const airId = gearData?.air_id;
            // `subscription` is nested by the gear read endpoints; null when the
            // device has no SubscriptionRecord (always null for instances).
            const subscription = gearData?.subscription;
            // Reuse the filter options as the status value
            const subscriptionStatus = gearSubscriptionStatusFilterOptions
              .find(option => option.value === subscription?.status)?.label ?? PLACEHOLDER;
            const startDate = formatDate(subscription?.current_term_start);
            const endDate = formatDate(subscription?.current_term_end);
            const planName = subscription?.plan_name ?? PLACEHOLDER;
            // Coverage status drives colour (active=green, expired/cancelled=red,
            // none=grey, via GearSubscriptionStatusText's palette).
            const supportStatus = gearData?.support_coverage?.status;
            const coveredUntil = formatDate(gearData?.support_coverage?.covered_until);
            // Active shows the end date; ended coverage shows its state (real date
            // preserved server-side, kept in the tooltip).
            const supportLabel =
              supportStatus === 'active' ? coveredUntil
              : supportStatus === 'expired' ? 'Expired'
              : supportStatus === 'cancelled' ? 'Cancelled'
              : PLACEHOLDER;

            return (
              <GearListRow key={index}>
                <GearAvatarDiv>
                  <CollabolatorsAvatar
                    src={deviceType === 'AIR One™' ? RobotIcon : InsIcon}
                  />
                </GearAvatarDiv>
                <GearListCell>
                  <div>
                    <EachCollabolatorsP title={nickname}>
                      {nickname}
                    </EachCollabolatorsP>
                    <EachCollabolatorsP6P title={airId}>
                      {airId}
                    </EachCollabolatorsP6P>
                  </div>
                </GearListCell>
                <GearListCell>
                  <EachCollabolatorsP2Div>
                    <div>
                      <p title={deviceType}>
                        {deviceType}
                      </p>
                    </div>
                  </EachCollabolatorsP2Div>
                </GearListCell>
                <GearListCell>
                  <GearSubscriptionStatusText $status={subscription?.status} title={subscriptionStatus}>
                    {subscriptionStatus}
                  </GearSubscriptionStatusText>
                </GearListCell>
                <GearListCell>
                  <EachCollabolatorsP3P>
                    {startDate}
                  </EachCollabolatorsP3P>
                </GearListCell>
                <GearListCell>
                  <EachCollabolatorsP3P>
                    {endDate}
                  </EachCollabolatorsP3P>
                </GearListCell>
                <GearListCell>
                  <EachCollabolatorsP3P title={planName}>
                    {planName}
                  </EachCollabolatorsP3P>
                </GearListCell>
                <GearListCell>
                  <GearSubscriptionStatusText $status={supportStatus} title={coveredUntil}>
                    {supportLabel}
                  </GearSubscriptionStatusText>
                </GearListCell>
                <GearListCell onClick={() => editGear(gearData, index)}>
                  <EachCollabolatorsP5P>Edit</EachCollabolatorsP5P>
                </GearListCell>
              </GearListRow>
            );
          })}
      </Collabolators>
      <SearchFooter
        postsPerPage={postsPerPage}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
        prePage={prePage}
        nextPg={nextPg}
        count={gearsList?.length || 0}
      />
    </>
  );
};

export default GearsList;
